import axios from "axios"
import NProgress from "nprogress"

const apiMCap = axios.create({
  baseURL: "https://api.icap-maker.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
})

apiMCap.interceptors.request.use(config => {
  NProgress.start()
  return config
})

apiMCap.interceptors.response.use(response => {
  NProgress.done()
  return response
})

export default {
  get_months() {
    return apiMCap.get("/ClientDirect/Batches/")
  },
  //   ,
  //   Load_Month(value) {
  //     return apiMCap({
  //       method: "post",
  //       url: "/Order/OneTimeOrder/",
  //       data: {
  //         _orderID: value
  //       }
  //     }) //.then(function(response) {
  //     //   user.UserProfileID = response.data["SaveUserResult"]
  //     // })
  get_ClientDirectOrders(value) {
    return apiMCap({
      method: "post",
      url: "/ClientDirect/Orders/",
      data: {
        _capBase: value
      }
    })
  },
  get_ClientDirectRecipients(value) {
    return apiMCap({
      method: "post",
      url: "/ClientDirect/OrderDetails/",
      data: {
        _orderID: value
      }
    })
  }
}
